import React from 'react';
import { useSelector } from 'react-redux';
import { Form, Button, message } from 'antd';
import { useTranslation } from 'react-i18next'; // Import the translation hook
import { convertKeyToCamelCase, beautifyKey } from '../../../utils/functions';
import { renderField } from '../utils/renderUIComponents';
import { optionalIdentifierRule } from '../../../utils/ukIdentifierValidation';
import ResponsiveFormLayout from '../utils/ResponsiveFormLayout';
import ApiErrorAlert from '../../common/ApiErrorAlert';
import '../utils/FormStyles.css';

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const CreateForm = ({
  newEntity,
  loadingCreate,
  handleSubmitNewEntity,
  errorCreate,
  singularEntity,
  entityDtoConfig,
  handleNewEntityInputChange,
  handleBrowseEntity,
  fieldsToHide,
  newForm
}) => {
  const { t } = useTranslation(); // Initialize the translation hook

  const userInfo = useSelector(state => state.userLogin.userInfo);

  return (
    <div style={{ paddingBottom: 52 }}>
      <Form
        form={newForm}
        name='newForm'
        layout='vertical'
        size='large'
        disabled={loadingCreate || newEntity === null}
        onFinish={handleSubmitNewEntity}
        onFinishFailed={() => {
          message.error(t('Please fill in all required fields')); // Use the translation function
        }}
      >
        <h3>{t('New')} {t(singularEntity)}</h3>
        <ApiErrorAlert error={errorCreate} title={t('Validation Error')} closable />
        <ResponsiveFormLayout fieldsConfig={entityDtoConfig}>
          {Object.entries(entityDtoConfig)?.map(([fieldName, fieldProps]) => (
            fieldsToHide?.includes(fieldName) ? null :
            <Form.Item
              key={`form-item-${fieldName}`}
              label={t(beautifyKey(fieldName))}
              name={fieldProps.type !== 'DateTime' ? convertKeyToCamelCase(fieldName) : undefined}
              rules={[
                {
                  required: fieldProps.isRequired,
                  message: fieldProps.errorMessage ? t(fieldProps.errorMessage) : t('This field is required'),
                  ...(fieldProps.isRequired && fieldProps.type === 'Guid' && {
                    validator: (_, val) =>
                      val && val !== EMPTY_GUID
                        ? Promise.resolve()
                        : Promise.reject(new Error(fieldProps.errorMessage ? t(fieldProps.errorMessage) : t('This field is required'))),
                  }),
                },
                optionalIdentifierRule(fieldName),
              ].filter(Boolean)}
              style={{ marginBottom: 0 }}
            >
              {renderField(fieldName, fieldProps, newEntity, handleNewEntityInputChange, handleBrowseEntity, userInfo)}
            </Form.Item>
          ))}
        </ResponsiveFormLayout>

        <div className="responsive-form-submit">
          <div className="responsive-form-submit-message">
            {t('Complete the form and submit to create')}
          </div>
          <div className="responsive-form-submit-actions">
            <Form.Item style={{ marginBottom: 0 }}>
              <Button type="primary" htmlType="submit" loading={loadingCreate}>
                {t('Submit')}
              </Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default CreateForm;
